import { ViteReactSSG } from 'vite-react-ssg';
import { routes } from './routes';
import './index.css';

export const createRoot = ViteReactSSG(
  { routes },
  () => {
    // Custom setup if needed
    // This runs on both server (SSG) and client (hydration)
  }
);

export default createRoot;
